import React from 'react'

function ServiceCard(props) {
    return (
        <div>
                 <div className="s-box">
                    <div className="b-container">
                        <div className="s-b-img">
                            <img src={props.image} alt="" />
                            <div className="s-b-text">
                                <a href="">
                                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi, non?</p>
                                </a>
                            </div>
                            <div className="s-type"></div>
                        </div>

                    </div>
                </div>
        </div>
    )
}

export default ServiceCard
